export default __webpack_public_path__ + "static/media/laram8.b2380735.jpg";